import Vue from "vue";
import ListSfSupplierRepository from "@/repositories/monocle/ListSfSupplierRepository";

export interface MonocleSupplier {
    uuid: string;
    label: string;
}

export default {
    state: {
        suppliers: [],
    },
    mutations: {
        setMonocleSuppliers: (
            state: any,
            suppliers: MonocleSupplier[]
        ) => {
            Vue.set(state, "suppliers", suppliers);
        },
    },
    getters: {
        getMonocleSuppliers: (state: any): MonocleSupplier[] => {
            return state.suppliers;
        },
    },
    actions: {
        loadMonocleSuppliers: ({ commit }: any) => {
            return new Promise((resolve: (value: object) => void, reject: (value: object) => void) => {
                const orders = { default: "DESC", label: "ASC" };
                const params = { orders };
                ListSfSupplierRepository.get(params).then((data: any) => {
                    commit("setMonocleSuppliers", data);
                    resolve(data);
                }).catch((reason: any) => {
                    reject(reason);
                });
            });
        },
    },
};
